var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("addShipmentFromForecast"),
      large: "",
      hideFooter: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("closeCreateShipments")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c("ToEveryone", {
              attrs: {
                selectedPackages: _vm.selectedPackages,
                isSplitShipment: _vm.isSplitShipment,
                onlyOneLabel: ""
              },
              on: { submitted: _vm.submitted },
              scopedSlots: _vm._u([
                {
                  key: "leftBtn",
                  fn: function() {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$emit("closeCreateShipments")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("close")))]
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7da6a660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da6a660","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForecastAddShipment.vue
// module id = null
// module chunks = 